import { intl } from "dmsbasereact";
import React, { useRef } from "react";

import {
    DmsButtonGroup,
    DmsPermissions,
    DmsTable,
    DmsTableCreateButton,
    DmsTableDeleteButton,
    DmsTableEditButton,
    DmsFlexContainer,
    Permissions,
    fetchData,
    HTTP_STATUS
} from "dmsbasereact";

import Swal from "sweetalert2";


/*
* Description: This component is the DMS roles page
* Props: none
*/
export const LenaPartTable = () => {
    const table = useRef(null);

    const header = [
        {
            label: intl.get("Name").d("Name"),
            column_name: "name",
            filter: true
        },
        {
            label: intl.get("Number").d("Number"),
            column_name: "number",
            filter: true
        },
        {
            label: intl.get("Description").d("Description"),
            column_name: "description",
            filter: true
        },
        {
            label: intl.get("GTIN").d("GTIN"),
            column_name: "gtin",
            filter: true
        },
        {
            label: intl.get("MaterialCode").d("Material Code"),
            column_name: "material_code",
            filter: true
        },
        {
            label: intl.get("Actions").d("Actions"),
            column_name: "actions",
            permissions: [Permissions.CAN_EDIT_PART],
            width: "80px",
            sortable: false,
            can_create: false,
            can_edit: false,
            element: (row) => {
                const name = row.name;
                return (
                    <DmsButtonGroup>
                        <DmsTableEditButton
                            table={table}
                            title={intl.get("Updatepart_name", { name }).d(`Update {name}`)}
                            url="/part/with_parameters/"
                            row={row}
                        />
                        <DmsTableDeleteButton
                            table={table}
                            title={intl.get("Deletepart_name", { name }).d(`Delete {name}`)}
                            text={intl.get("DmsPartTable.DeleteButtonMessage", { name }).d(`The part {name} will be deleted. Are you sure about it?`)}
                            url="/part/with_parameters/"
                            row_pk={row.pk}
                        />
                    </DmsButtonGroup>
                )
            }
        },
    ]

    const createPart = async (data) => {
        const url = "/part/with_parameters/";
        const response = await fetchData(url, "POST", true, data);

        if (response.status === HTTP_STATUS.CREATED_201) {
            Swal.fire({
                icon: "success",
                title: intl.get("PartCreated").d("Part Created"),
            });

            table.current.updateTable();

            
        } else {
            const errorDetail = response?.data?.detail;
            const errorMessage = typeof errorDetail === 'string'
                ? errorDetail
                : (errorDetail?.message || errorDetail?.msg || JSON.stringify(errorDetail) || intl.get("UnknownError").d("Unknown error"));
            Swal.fire({
                icon: "error",
                title: intl.get("Error").d("Error"),
                text: errorMessage,
            });
        }
    };

    const toolbar = <DmsFlexContainer>
        <DmsFlexContainer.Left>
            <DmsPermissions permissions={Permissions.CAN_EDIT_PART}>
                <DmsTableCreateButton
                    header={header}
                    table={table}
                    title={intl.get("Createpart").d("Create part")}
                    handler={createPart}
                />
            </DmsPermissions>
        </DmsFlexContainer.Left>
    </DmsFlexContainer>

    return (
        <>
            <DmsTable
                header={header}
                managed={true}
                needs_authentication={true}
                export_table={false}
                ref={table}
                url={'/part/table_with_parameters/'}
                toolbar={toolbar}
            />
        </>
    )
}

